import React, { useEffect, useState } from 'react';
import './Header.css';
import cc2 from '../../assets/images/cc2.jpg';
import fsc from '../../assets/images/fsc.jpg';
import videoThumbnail from '../../assets/images/video-thumbnail.jpg';
import { LuArrowUpRight } from "react-icons/lu";
import { useTranslation } from 'react-i18next';
import EmojiText from '../EmojiText/EmojiText';
import { FaPlay } from "react-icons/fa";

// CONTACT BUTTONS (circular text buttons)
const RotatedText: React.FC<{ text: string }> = ({ text }) => {
    return (
        <p>
            {text.split('').map((character, index) => (
                <span key={index} style={{ transform: `rotate(${index * 12.55}deg)` }}>
                    <EmojiText>{character}</EmojiText>
                </span>
            ))}
        </p>
    );
};

const Header: React.FC = () => {

    const { t } = useTranslation();
    const [videoLoaded, setVideoLoaded] = useState(false);
    const [iframeKey, setIframeKey] = useState(0);

    // CONTACT BUTTONS (circular text buttons)
    const [, setText] = useState('');

    useEffect(() => {
        const textButtons = document.querySelectorAll<HTMLAnchorElement>('.contact__btn');

        textButtons.forEach(textButton => {
            const p = textButton.querySelector<HTMLParagraphElement>('p');
            if (p) {
                setText(p.innerText);
            }
        });
    }, []);

    const handleVideoClick = () => {
        // Pequeño delay para asegurar que el DOM esté listo
        setTimeout(() => {
            setVideoLoaded(true);
            setIframeKey(prev => prev + 1); // Forzar re-render del iframe
        }, 100);
    };

    return (
        <>
            <header>
                <div className="container header__container">
                    <div className="header__left">
                        <div className="header__head">
                            <span className="header__tag">#FSCcertified2026</span>
                        </div>
                        <h1>{t('header_title')}</h1>
                        <p>{t('header_paragraph')}</p>
                        {/* <a href="mailto:support@egattor.com" className="header__btn-md"></a> */}
                    </div>
                    <div className="header__right">
                        <div className="videoFrame">
                            {!videoLoaded ? (
                                <div className="video-thumbnail" onClick={handleVideoClick}>
                                    <img 
                                        src={videoThumbnail} 
                                        alt="Davidson" 
                                        className="thumbnail-image"
                                    />
                                    <div className="play-button">
                                        <FaPlay />
                                    </div>
                                </div>
                            ) : (
                                <iframe
                                    key={`youtube-${iframeKey}`}
                                    src="https://www.youtube.com/embed/Sa62F8k1swU?autoplay=1&rel=0&modestbranding=1&playsinline=1&enablejsapi=1&mute=0"
                                    title="Video player"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen
                                    referrerPolicy="strict-origin-when-cross-origin">
                                </iframe>
                            )}
                        </div>
                    </div>
                </div>
            </header>
            <div className="header__frames">
                <div className="header__frame">
                    <img src={cc2} alt="Header Frame One" />
                </div>
                <div className="header__frame">
                    <img src={fsc} alt="Header Frame Two" />
                </div>
            </div>
            <a href="#foot" className="contact__btn header__btn">
                <LuArrowUpRight className="contact__btn-icon" />
                <RotatedText text={t('header_contact_btn')} />
            </a>
        </>
    );
}

export default Header;
